import GestioneAttivitaProgettiListPage from "./pages/GestioneAttivitaProgettiListPage.vue";
import GestioneAttivitaProgettiEditPage from "./pages/GestioneAttivitaProgettiEditPage.vue";
import GestioneAttivitaProdottiListPage from "./pages/GestioneAttivitaProdottiListPage.vue";
import GestioneAttivitaProdottiEditPage from "./pages/GestioneAttivitaProdottiEditPage.vue";
import GestioneAttivitaModuliListPage from "./pages/GestioneAttivitaModuliListPage.vue";
import GestioneAttivitaModuliEditPage from "./pages/GestioneAttivitaModuliEditPage.vue";
import GestioneAttivitaAttivitaListPage from "./pages/GestioneAttivitaAttivitaListPage.vue";
import GestioneAttivitaAttivitaEditPage from "./pages/GestioneAttivitaAttivitaEditPage.vue";
import GestioneAttivitaTasksListPage from "./pages/GestioneAttivitaTasksListPage.vue";
import GestioneAttivitaTasksEditPage from "./pages/GestioneAttivitaTasksEditPage.vue";
import GestioneAttivitaAttivitaDettaglioPage from "./pages/GestioneAttivitaAttivitaDettaglioPage.vue";
import GestioneAttivitaBachecaPage from "./bacheca/pages/AttivitaBachecaList.vue";
import GestioneAttivitaTasksDettaglioPage from "./pages/GestioneAttivitaTasksDettaglioPage.vue";
import GestioneAttivitaClientiListPage from "./pages/GestioneAttivitaClientiListPage.vue";
import GestioneAttivitaClientiEditPage from "./pages/GestioneAttivitaClientiEditPage.vue";
import GestioneAttivitaProdottiDettaglioPage from "./pages/GestioneAttivitaProdottiDettaglioPage.vue";
import GestioneAttivitaProgettiDettaglioPage from "./pages/GestioneAttivitaProgettiDettaglioPage.vue";

export default {
	GestioneAttivitaProgettiListPage,
	GestioneAttivitaProgettiEditPage,
	GestioneAttivitaProdottiListPage,
	GestioneAttivitaProdottiEditPage,
	GestioneAttivitaProdottiDettaglioPage,
	GestioneAttivitaModuliListPage,
	GestioneAttivitaModuliEditPage,
	GestioneAttivitaAttivitaListPage,
	GestioneAttivitaAttivitaEditPage,
	GestioneAttivitaBachecaPage,
	GestioneAttivitaAttivitaDettaglioPage,
	GestioneAttivitaTasksListPage,
	GestioneAttivitaTasksEditPage,
	GestioneAttivitaTasksDettaglioPage,
	GestioneAttivitaClientiListPage,
	GestioneAttivitaClientiEditPage,
	GestioneAttivitaProgettiDettaglioPage,
};
